<!--数字-->
<template>
  <el-input-number
    v-model="value"
    v-bind="$attrs"
    :id="'c' + formItemMeta.columnId"
    :name="'c' + formItemMeta.columnId"
    :clearable="clearable"
    :controls-position="controlsPosition"
  >
  </el-input-number>
  <circle-close-filled v-if="clearable"
    style="width: 1.2em; height: 1.2em; margin-top: 0px; margin-left: 5px;cursor: pointer;"
    @click.stop="myclear" 
  />
</template>

<script lang="ts">
  import { defineComponent, nextTick } from 'vue'
  import { CircleCloseFilled } from '@element-plus/icons-vue'
  // import { ElInputNumber } from 'element-plus'
  // 引入组件需要的属性 引入表单子控件的管理类
  import { itemProps, itemController } from '../map'

  export default defineComponent({
    name: 'nf-el-from-item-number',
    inheritAttrs: false,
    components: {
      CircleCloseFilled
    },
    props: {
      ...itemProps, // 基础属性
      controlsPosition: {
        type: String,
        default: 'right'
      },
      colName: String, // 变更字段名称
      modelValue: [String, Number]
    },
    emits: ['update:modelValue'],
    setup (props, context) {
      const {
        value
      } = itemController(props, context.emit)

      const myclear = () => {
        value.value = false
        nextTick(() => {
          value.value = null
        })
      }

      return {
        myclear,
        value
      }
    }
  })
</script>
